export const countryConfigPT = {
  home: {
    skeleton: {
      banner: true,
      bubbles: true,
      featuredProducts: true,
      services: true,
      starredProductLists: 4,
      starredCards1: true,
      starredCards2: true,
      posts: false
    }
  },
  'landing-courier': {
    bikeCollection: 'para-bicicletas-e-scooters',
    carCollection: 'para-condutores-de-carro'
  },
  'landing-custom-products': {
    quickCustomization: 'express-3',
    proCustomization: 'pro-3d-3',
    design: 'pro-3d-3',
    logo: 'pro-3d-3'
  }
};
